// extracted by mini-css-extract-plugin
export var content = "styles-module--content--532be";
export var fadeInDown = "styles-module--fadeInDown--3bdeb";
export var firstGlow = "styles-module--first-glow--41c62";
export var mainTitle = "styles-module--main-title--4ca9f";
export var showMoreIcon = "styles-module--showMore-icon--281b3";
export var showMoreText = "styles-module--showMore-text--eb080";
export var showMoreWrapper = "styles-module--showMore-wrapper--81ab2";
export var suptitle = "styles-module--suptitle--d4407";